import { Store } from '@toeverything/infra';
import { map } from 'rxjs';

import type { WorkspaceDBService } from '../../db';

export class FolderTemplateListStore extends Store {
  constructor(private readonly dbService: WorkspaceDBService) {
    super();
  }

  isTemplateFolder(folderId: string) {
    return !!this.dbService.db.folderProperties.get(folderId)?.isTemplate;
  }

  watchTemplateFolder(folderId: string) {
    return this.dbService.db.folderProperties
      .get$(folderId)
      .pipe(map(res => !!res?.isTemplate));
  }

  setTemplateFolder(folderId: string, isTemplate: boolean) {
    this.dbService.db.folderProperties.create({
      id: folderId,
      isTemplate,
    });
  }

  getTemplateFolderIds() {
    return this.dbService.db.folderProperties
      .find({ isTemplate: true })
      .map(property => property.id);
  }

  watchTemplateFolders() {
    return this.dbService.db.folderProperties.find$({ isTemplate: true });
  }
}
